(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["image-comparison-slide"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('image-comparison-slider')) {
    customElements.define(
      'image-comparison-slider',
      class ImageComparisonSlider extends HTMLElement {
        constructor() {
          super();
          this.container = this.querySelector('.image-comparison__container');
          this.inputRange = this.querySelector('.image-comparison__slider');
          this.selectRadios = this.querySelectorAll('.image-comparison__selectors input[type="radio"]');
          this.beforeImage = this.querySelector('.image-comparison__image-before');
          this.afterImage = this.querySelector('.image-comparison__image-after');
          this.userHasInteracted = false; // Track if user has interacted with the slider
          this.initRangeSlider();
          this.initRadios();
          this.initScrollTrigger();
        }

        initRangeSlider() {
          if (!(this.inputRange && this.container)) return;
          this.inputRange.addEventListener('input', (e) => {
            this.container.style.setProperty('--image-comparison-position', `${e.target.value}%`);
            // Mark that user has interacted with the slider
            if (!this.userHasInteracted) {
              this.userHasInteracted = true;
              this.classList.add('user-interacted');
            }
          });
        }

        // Phones (under 750 px, where the frame is square) get square crops; wider screens the 16:9 1300w.
        setImage(img, url) {
          const source = img.parentElement?.querySelector('source');
          if (source) {
            source.srcset = `${url}&width=500&height=500&crop=center 500w, ${url}&width=800&height=800&crop=center 800w`;
          }
          img.src = `${url}&width=1300`;
        }

        onRadioChange(e) {
          if (
            this.beforeImage &&
            this.afterImage &&
            e.currentTarget &&
            e.currentTarget.dataset &&
            e.currentTarget.dataset.beforeUrl &&
            e.currentTarget.dataset.afterUrl
          ) {
            this.setImage(this.beforeImage, e.currentTarget.dataset.beforeUrl);
            this.setImage(this.afterImage, e.currentTarget.dataset.afterUrl);
            // Mark that user has interacted with the slider
            if (!this.userHasInteracted) {
              this.userHasInteracted = true;
              this.classList.add('user-interacted');
            }
          }
        }

        initRadios() {
          if (!(this.selectRadios && this.selectRadios.length)) return;
          [].forEach.call(this.selectRadios, (radio) => {
            radio.addEventListener('input', this.onRadioChange.bind(this));
          });
        }

        initScrollTrigger() {
          const observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting) {
                  this.classList.add('scroll-trigger');
                } else {
                  this.classList.remove('scroll-trigger');
                }
              });
            },
            { threshold: 0.3 }
          );
          observer.observe(this);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-mix-match"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
